import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus2",
  "use": "plus2-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" id=\"plus2\">\n  <g stroke=\"currentColor\" fill=\"currentColor\" fill-rule=\"evenodd\">\n    <polygon points=\"0 8 0 6.5 6 6.5 6 0 7.5 0 7.5 6.5 14 6.5 14 8 7.5 8 7.5 15 6 15 6 8\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol